var $4e11db3c25a38112$exports = {};
$4e11db3c25a38112$exports = {
  "ascending": "t\xF5usev j\xE4rjestus",
  "ascendingSort": function ascendingSort(args) {
    return "sorditud veeru j\xE4rgi ".concat(args.columnName, " t\xF5usvas j\xE4rjestuses");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pikslit");
  },
  "descending": "laskuv j\xE4rjestus",
  "descendingSort": function descendingSort(args) {
    return "sorditud veeru j\xE4rgi ".concat(args.columnName, " laskuvas j\xE4rjestuses");
  },
  "resizerDescription": "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  "select": "Vali",
  "selectAll": "Vali k\xF5ik",
  "sortable": "sorditav veerg"
};
export { $4e11db3c25a38112$exports as default };